// Port of api/fuel/app/classes/filter/collection.php
import Filter from 'offline/filter/core/filter'
import F from 'offline/filter/constants'
import DB from 'offline/db'
import AdvancedCollection from 'offline/filter/advanced/collection'

function collectionMaximum(userIds) {
	if (!userIds || !userIds.length) return 0
	if (userIds.length === 1) {
		return Number(DB.scalar('SELECT COUNT(*) FROM collection WHERE user_id = ?', [userIds[0]]) || 0)
	}

	var placeholders = userIds.map(function() { return '?' }).join(',')
	return Number(DB.scalar('SELECT COUNT(*) FROM collection WHERE user_id IN (' + placeholders + ')', userIds) || 0)
}

function collectionStatusCount(status) {
	if (!status || typeof status !== 'object') return 0

	var statusKeys = ['own', 'prevowned', 'fortrade', 'want', 'wanttoplay', 'wanttobuy', 'wishlist', 'preordered', 'hasparts', 'wantparts']
	var count = 0
	for (var i = 0; i < statusKeys.length; i++) {
		if (status[statusKeys[i]]) count++
	}

	return count
}

var Collection = Filter.extend({
	filter_type: F.TYPE_GAMES,
	cache_type: F.CACHE_COLLECTION,
	result_type: F.RESULT_COLLECTION,
	pseudo_type: F.PSEUDO_COLLECTION,
	json_package: 'collection',
	package_types: [F.PACKAGE_GAME, F.PACKAGE_COLLECTION],
	required_filter: {
		source: {
			collection: true
		}
	},

	configure: function(config) {
		if (config.ownerType !== F.OWNER_USER) {
			config.resultType = F.RESULT_GAME
			config.pseudoType = F.PSEUDO_GAME
		}
		return config
	},

	search: function(data) {
		data = Filter.prototype.search.call(this, data)

		var leaksNonOwned = false

		if (this._filter && this._filter.advanced && typeof this._filter.advanced === 'object') {
			leaksNonOwned = AdvancedCollection.fails(this._filter.advanced)

			if (leaksNonOwned) {
				data.maximum = collectionMaximum(this._config.users)
			} else {
				data.maximum = Number(this._config.owner.get_count_collection() || 0)
			}
		}

		if (this._filter && this._filter.status && typeof this._filter.status === 'object' && !leaksNonOwned) {
			var statusCount = collectionStatusCount(this._filter.status)

			if (statusCount > 1 || (statusCount === 1 && Number(this._filter.status.own) !== 1)) {
				data.maximum = collectionMaximum(this._config.users)
			} else {
				data.maximum = Number(this._config.owner.get_count_collection() || 0)
			}
		} else if (!leaksNonOwned) {
			data.maximum = Number(this._config.owner.get_count_collection() || 0)
		}

		return data
	}
})

export default Collection
